import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export default function PageTransition({ children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.25, ease: [0.22, 1, 0.36, 1] } }}
        exit={{ opacity: 0, y: -20, transition: { duration: 0.45, ease: "easeIn" } }}
      >
        {children}
      </motion.div>
      <motion.div
        aria-hidden="true"
        className="fixed inset-0 z-[95] bg-ink border-b-2 border-gold-light pointer-events-none origin-top"
        initial={{ scaleY: 1 }}
        animate={{ scaleY: 0, transition: { duration: 0.75, ease: EASE } }}
        exit={{ scaleY: 0 }}
      />
      <motion.div
        aria-hidden="true"
        className="fixed inset-0 z-[95] bg-ink border-t-2 border-gold-light pointer-events-none origin-bottom"
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 1, transition: { duration: 0.5, ease: EASE } }}
      />
    </>
  );
}
